import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

const CLOSE_DELAY = 3000;
const ERROR_NOTIFICATION_LIMIT = 5;
const ERROR_CONTAINER_ID = 'errors-wlabel';

export function catchAndNotify(err: ErrorNotification) {
  // NOTE: no storage
}

export function catchSilently(err: Error) {
  // NOTE: no storage
}

export function ErrorBox() {
  return (
    <ToastContainer
      enableMultiContainer
      containerId={ERROR_CONTAINER_ID}
      position={toast.POSITION.BOTTOM_RIGHT}
      autoClose={CLOSE_DELAY}
      limit={ERROR_NOTIFICATION_LIMIT}
      closeOnClick
      draggable
      pauseOnHover
    />
  );
}
